import Image from 'next/image';
import { useMemo } from 'react';

import { EventTriggerType, STRIPE_PAYMENT_EVENT_TYPE_LABELS, StripePaymentEventType, Trigger } from '../../domain';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export function StripePaymentTriggerDetails({ trigger, triggerType }: Props) {
  const paymentEventTypeLabel = useMemo(() => {
    const paymentEventType = trigger.context?.paymentEventType;
    if (!paymentEventType) {
      return '';
    }
    return STRIPE_PAYMENT_EVENT_TYPE_LABELS[paymentEventType as StripePaymentEventType] ?? paymentEventType;
  }, [trigger.context]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />
      <TriggerValueDetail
        label="Provider"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <Image src="/assets/svg/stripe.svg" width={16} height={16} alt="Stripe" />
            <span>Stripe</span>
          </div>
        }
      />
      <TriggerValueDetail label="Payment event" value={paymentEventTypeLabel} />
    </div>
  );
}
